import { render, staticRenderFns } from "./ModulesOrder.vue?vue&type=template&id=3d9315a0"
import script from "./ModulesOrder.vue?vue&type=script&lang=js"
export * from "./ModulesOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports